package one.healthium.profile.navigation.update_food

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner
import one.healthium.profile.ui.update_food.UpdateFoodScreen

@Composable
fun UpdateFoodContent(component: UpdateFoodComponent) {
    CompositionLocalProvider(LocalViewModelStoreOwner provides component) {
        UpdateFoodScreen(component.food, component)
    }
}